'use client';

import { createSlice } from '@reduxjs/toolkit';
import { SlideBarStateType } from '../types';

const initialState = {
  sidebarShow: true,
  theme: 'light',
} as SlideBarStateType;


export const slideBar = createSlice({
  name: 'slideBar',
  initialState,
  reducers: {
    changeState: (state, action) => {
      const actionType = action.payload.type;
      const { sidebarUnfoldable } = action.payload
      switch (actionType) {
        case 'set':
          return {
            ...state, ...action.payload, unfoldable: sidebarUnfoldable
          }
        default:
          return state
      }
    },
  },
});

export const { changeState } = slideBar.actions;
export default slideBar.reducer;